module.exports = __webpack_public_path__ + "static/media/placeholder.8b6c1cf0.svg";